import { useState } from "react";
import { motion } from "framer-motion";
import { Play } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const VIMEO_ID = "1210809574";
const POSTER_URL = "/images/villa-fachada.jpg";

export default function VideoSection() {
  const { t } = useLang();
  const [started, setStarted] = useState(false);

  return (
    <section id="video" data-testid="video-section" className="relative py-24 md:py-32 bg-[#F0EBE1]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-14 md:mb-20">
          <p className="text-xs md:text-sm uppercase tracking-[0.3em] text-[#C48E66] mb-6" data-testid="video-eyebrow">{t.video.eyebrow}</p>
          <h2 className="font-serif text-5xl md:text-6xl lg:text-7xl text-[#112A46] font-light leading-[1.02] tracking-tight" data-testid="video-title">
            {t.video.title_1}<span className="italic">{t.video.title_italic}</span>
          </h2>
          <p className="mt-6 text-[#5C665F] text-base md:text-lg leading-relaxed">{t.video.subtitle}</p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="relative group overflow-hidden bg-[#112A46]"
          data-testid="video-wrapper"
        >
          <div className="relative aspect-video">
            {started ? (
              <iframe
                src={`https://player.vimeo.com/video/${VIMEO_ID}?autoplay=1&title=0&byline=0&portrait=0&transparent=0`}
                title="Villa d'Avó Dalva"
                className="absolute inset-0 w-full h-full"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                data-testid="video-iframe"
              />
            ) : (
              <button
                onClick={() => setStarted(true)}
                data-testid="video-play-btn"
                aria-label="Play video"
                className="absolute inset-0 w-full h-full group/btn"
              >
                <img
                  src={POSTER_URL}
                  alt="Villa d'Avó Dalva"
                  className="absolute inset-0 w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-[#112A46]/15 via-transparent to-[#112A46]/60 group-hover/btn:from-[#112A46]/5 group-hover/btn:to-[#112A46]/70 transition-all duration-500" />
                <span className="absolute inset-0 flex items-center justify-center">
                  <span className="flex items-center justify-center w-24 h-24 md:w-32 md:h-32 rounded-full bg-[#FAFAF7]/95 text-[#112A46] group-hover/btn:bg-[#C48E66] group-hover/btn:text-[#FAFAF7] group-hover/btn:scale-110 transition-all duration-500 shadow-2xl">
                    <Play size={36} strokeWidth={1} className="ml-1" />
                  </span>
                </span>
                <div className="absolute bottom-6 left-6 md:bottom-10 md:left-10 text-[#FAFAF7] pointer-events-none">
                  <p className="font-serif italic text-2xl md:text-3xl font-light">{t.video.caption}</p>
                </div>
              </button>
            )}
          </div>
        </motion.div>

        <p className="mt-6 text-[11px] uppercase tracking-[0.25em] text-[#5C665F]" data-testid="video-hint">
          {t.video.hint}
        </p>
      </div>
    </section>
  );
}
